import type { WalletMonitoringGroup, WalletMonitoringItem } from '@shared/api/contracts';
import type { WalletGroupSection } from '../model/types';

export const buildWalletGroupSections = (
  groups: WalletMonitoringGroup[],
  wallets: WalletMonitoringItem[],
  groupSummaries: WalletMonitoringGroup[],
): WalletGroupSection[] => {
  const walletsByCode = new Map<string, WalletMonitoringItem[]>();

  for (const wallet of wallets) {
    const code = wallet.group.code;
    const list = walletsByCode.get(code) ?? [];
    list.push(wallet);
    walletsByCode.set(code, list);
  }

  const summaryByCode = new Map(
    groupSummaries.map((group) => [group.code, group.summary]),
  );

  return groups
    .slice()
    .sort((left, right) => left.sortOrder - right.sortOrder)
    .map((group) => ({
      group,
      wallets: walletsByCode.get(group.code) ?? [],
      summary: summaryByCode.get(group.code) ?? group.summary,
    }));
};
